export default "__VITE_ASSET__B9vi6IO6__"